import { ChatItemReplaceContainerProps } from './chatReplaceProps';
import { ChatItemReplaceController, ChatItemReplaceLoader } from './chatReplaceInterface';
import { ReportingShellContainerBaseConfig } from '../../../../base';

export function createChatItemReplaceContainer(
    config: ReportingShellContainerBaseConfig,
    loader: ChatItemReplaceLoader,
    controller: ChatItemReplaceController
): React.FC<ChatItemReplaceContainerProps> {
    const {
        repository: { research: repository },
        context: { useContext },
        pubsub: { router: pubsub },
    } = config;

    return ({ as: View, item, ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, { item });
        const props = controller.useProps(context, data, {
            onOpen() {
                console.log('opening document');
                pubsub.dispatch({
                    kind: 'open',
                    data: {
                        content: {
                            id: item.tool.args.document,
                        },
                    },
                });
            },
        });
        return <View {...props} />;
    };
}
